<template>
  <div class="d-flex justify-content-center pt-5">
    <template v-if="loading">
      <spinner variant="success" />
    </template>
    <div v-else>
      <h4 class="text-center">{{ seconds }}</h4>
      <label v-if="success">
        {{ $t('stripeForm.success-pay-object-msg') }}
      </label>
      <label v-else-if="success === false">
        Payment process failed
      </label>
    </div>
  </div>

  <message :message="message" :link="isMsg" :isVisible=isVisibleMsg @onVisible="changeIsVisibleMsg" />
</template>

<script src="./ObjectPaid.js"></script>
